import AdminReviews from './components/AdminReviews';
import React from "react";
import "./App.css";
import { LanguageProvider } from './context/LanguageContext';
import { Toaster } from './components/ui/sonner';
import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
import WhyChoose from './components/WhyChoose';
import Testimonials from './components/Testimonials';
import ServiceAreas from './components/ServiceAreas';
import Contact from './components/Contact';
import Footer from './components/Footer';
import WhatsAppButton from './components/WhatsAppButton';

function App() {

  const isAdmin = window.location.hash === "#admin-gr8-2025";

  return (
    <>
      {isAdmin ? (
        <AdminReviews />
      ) : (
        <LanguageProvider>
          <div className="App">
            <Header />
            <Hero />
            <About />
            <Services />
            <WhyChoose />
            <Testimonials />
            <ServiceAreas />
            <Contact />
            <Footer />
            <WhatsAppButton />
            <Toaster />
          </div>
        </LanguageProvider>
      )}
    </>
  );
}

export default App;
